<template>
  <div v-if="isGlobalLoading" class="global-loading">
    <div class="global-loading__panel">
      <span class="global-loading__spinner"></span>
      <div class="global-loading__text">加载中...</div>
    </div>
  </div>
</template>

<script setup>
import { isGlobalLoading } from '@/utils/loading';
</script>
